import httpRequest, { ApiConfig } from 'httpRequest'
import {
    PerformResetPasswordContract,
    UpdatePermissionContract,
    UpdateUserContract,
    UpdateUserPINContract,
    UserDataContract,
    UserPreferenceContract,
    UserRowModel,
} from 'models'
import { ResetPasswordRequestContract } from 'models/ResetPasswordRequestContract'

const COMPANY_USERS_PREFIX = '/company/users'
const CURRENT_USER_PREFIX = '/company/user'
const LOCATION_USERS_PREFIX = '/location/users'

const userService = {
    getCurrentUserData() {
        return httpRequest.get<UserDataContract>(`${CURRENT_USER_PREFIX}`)
    },
    getUsers: (config?: ApiConfig) =>
        httpRequest.get<UserRowModel[]>(`${COMPANY_USERS_PREFIX}`, config),

    createUser: (payload: UpdateUserContract) =>
        httpRequest.post<string>(`${COMPANY_USERS_PREFIX}`, payload),
    deleteUsers: (userIds: string[]) =>
        httpRequest.delete(`${COMPANY_USERS_PREFIX}`, { params: { userIds } }),

    getUser: (id: string) =>
        httpRequest.get<UpdateUserContract>(`${COMPANY_USERS_PREFIX}/${id}`),
    updateUser: (id: string, payload: UpdateUserContract) =>
        httpRequest.put(`${COMPANY_USERS_PREFIX}/${id}`, payload),
    getUserPermissionLocation: (userId: string) =>
        httpRequest.get<UpdatePermissionContract[]>(
            `${LOCATION_USERS_PREFIX}/${userId}/permission`,
        ),
    getCurrentLocationUsers: () =>
        httpRequest.get<UserRowModel[]>(`${LOCATION_USERS_PREFIX}`),
    upsertUserPermissionLocation: (
        userId: string,
        payload: UpdatePermissionContract[],
    ) =>
        httpRequest.post(
            `${LOCATION_USERS_PREFIX}/${userId}/permission`,
            payload,
        ),
    getUserPermissionCompany: (userId: string) =>
        httpRequest.get<UpdatePermissionContract[]>(
            `${COMPANY_USERS_PREFIX}/${userId}/permission`,
        ),
    upsertUserPermissionCompany: (
        userId: string,
        payload: UpdatePermissionContract[],
    ) =>
        httpRequest.post(
            `${COMPANY_USERS_PREFIX}/${userId}/permission`,
            payload,
        ),
    getUserRoleLocation: (userId: string) =>
        httpRequest.get<string[]>(`${LOCATION_USERS_PREFIX}/${userId}/role`),
    upsertUserRoleLocation: (userId: string, payload: string[]) =>
        httpRequest.post<string[]>(
            `${LOCATION_USERS_PREFIX}/${userId}/role`,
            payload,
        ),
    getUserRoleCompany: (userId: string) =>
        httpRequest.get<string[]>(`${COMPANY_USERS_PREFIX}/${userId}/role`),
    upsertUserRoleCompany: (userId: string, payload: string[]) =>
        httpRequest.post<string[]>(
            `${COMPANY_USERS_PREFIX}/${userId}/role`,
            payload,
        ),
    checkPinStatus: (userId: string) =>
        httpRequest.get<boolean>(`${LOCATION_USERS_PREFIX}/${userId}/pin`),
    deleteUserPin: (userId: string) =>
        httpRequest.delete(`${LOCATION_USERS_PREFIX}/${userId}/pin`),
    updateUserPIN: (userId: string, newPin: string) =>
        httpRequest.put<UpdateUserPINContract>(
            `${LOCATION_USERS_PREFIX}/${userId}/pin`,
            {
                userId,
                newPin,
            },
        ),
    deactiveUser: (userId: string) =>
        httpRequest.put(`${COMPANY_USERS_PREFIX}/${userId}/inactive`),
    activeUser: (userId: string) =>
        httpRequest.put(`${COMPANY_USERS_PREFIX}/${userId}/active`),

    changePassword(body: { currentPassword: string; newPassword: string }) {
        return httpRequest.put(`${CURRENT_USER_PREFIX}/change-password`, body)
    },

    setUserPreference(body: UserPreferenceContract) {
        return httpRequest.post(`${CURRENT_USER_PREFIX}/preference`, body)
    },
    requestForResetPassword(payload: ResetPasswordRequestContract) {
        return httpRequest.post(
            `${COMPANY_USERS_PREFIX}/request-password-reset`,
            payload,
        )
    },
    resetPassword(payload: PerformResetPasswordContract) {
        return httpRequest.post(
            `${COMPANY_USERS_PREFIX}/reset-password`,
            payload,
        )
    },
    getSuperUserIds: () =>
        httpRequest.get<string[]>(`${COMPANY_USERS_PREFIX}/super-users`),
}

export default userService
